import { render, staticRenderFns } from "./Websocket.vue?vue&type=template&id=70e64411"
import script from "./Websocket.vue?vue&type=script&lang=js"
export * from "./Websocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports